var _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPptx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9961 1.99805H5.99609C5.46566 1.99805 4.95695 2.20876 4.58188 2.58383C4.20681 2.95891 3.99609 3.46761 3.99609 3.99805V19.998C3.99609 20.5285 4.20681 21.0372 4.58188 21.4123C4.95695 21.7873 5.46566 21.998 5.99609 21.998H17.9961C18.5265 21.998 19.0352 21.7873 19.4103 21.4123C19.7854 21.0372 19.9961 20.5285 19.9961 19.998V8.99805L12.9961 1.99805Z",
    stroke: "#7755FF",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9961 1.99805V8.99805H19.9961",
    stroke: "#7755FF",
    strokeWidth: 1.71429,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 14,
    width: 24,
    height: 10,
    rx: 2,
    fill: "#7755FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.98 22V15.52H5.156C5.54533 15.52 5.86533 15.5947 6.116 15.744C6.36667 15.888 6.55333 16.1013 6.676 16.384C6.79867 16.6613 6.86 17 6.86 17.4C6.86 17.9013 6.77733 18.2853 6.612 18.552C6.44667 18.8133 6.22267 18.9947 5.94 19.096C5.65733 19.1973 5.34 19.248 4.988 19.248H4.412V22H2.98ZM4.412 18.248H4.892C5.068 18.248 5.20133 18.216 5.292 18.152C5.38267 18.088 5.44133 17.992 5.468 17.864C5.5 17.736 5.516 17.5733 5.516 17.376C5.516 17.2107 5.50267 17.0667 5.476 16.944C5.45467 16.816 5.39867 16.7147 5.308 16.64C5.21733 16.5653 5.076 16.528 4.884 16.528H4.412V18.248ZM8.03031 22V15.52H10.2063C10.5956 15.52 10.9156 15.5947 11.1663 15.744C11.417 15.888 11.6036 16.1013 11.7263 16.384C11.849 16.6613 11.9103 17 11.9103 17.4C11.9103 17.9013 11.8276 18.2853 11.6623 18.552C11.497 18.8133 11.273 18.9947 10.9903 19.096C10.7076 19.1973 10.3903 19.248 10.0383 19.248H9.46231V22H8.03031ZM9.46231 18.248H9.94231C10.1183 18.248 10.2516 18.216 10.3423 18.152C10.433 18.088 10.4916 17.992 10.5183 17.864C10.5503 17.736 10.5663 17.5733 10.5663 17.376C10.5663 17.2107 10.553 17.0667 10.5263 16.944C10.505 16.816 10.449 16.7147 10.3583 16.64C10.2676 16.5653 10.1263 16.528 9.93431 16.528H9.46231V18.248ZM13.6646 22V16.584H12.6886V15.52H16.0726V16.584H15.1046V22H13.6646ZM16.6991 22L17.9551 18.512L16.7551 15.52H18.1071L18.8191 17.272L19.3951 15.52H20.5871L19.4511 18.888L20.7151 22H19.3711L18.5791 20.064L17.8831 22H16.6991Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPptx);
export default __webpack_public_path__ + "static/media/pptx.b65cad5b1089f604948bee42a7ea4430.svg";
export { ForwardRef as ReactComponent };